// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__bWgas","calendarButtons":"ClockData_calendarButtons__QNwpH"};